'use strict';

import _ from 'lodash';

const planDurations = require('../data/planDurations');

module.exports = function(planDuration) {
	return _.endsWith(planDuration, '-recurring') || planDuration === planDurations.YEARLY;
};
